<template>
    <modal ref="modal" class="mark-multiple-short-channels-orders-invoiced-modal" @closed="onModalClose">
        <template #header="sp">
            <div class="h3">Marquer les commandes comme distribuées</div>
        </template>
        <template #body="sp">
            <table class="table table-striped table-sm">
                <tbody>
                    <tr v-for="order in displayedOrders" :key="order.id">
                        <td>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" :id="'order_' + order.id" v-model="selectedOrders" :value="order.id" :disabled="sending">
                                <label :for="'order_' + order.id" class="form-check-label">{{ order.location_name }}</label>
                                <div v-if="sendingOrderId === order.id" class="d-inline-block text-muted">
                                    <i class="far fa-spinner fa-spin"></i> En cours
                                </div>
                            </div>
                            <errors-zone v-if="allErrors && allErrors[order.id]" :errors="allErrors[order.id]" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template #footer>
            <button type="button" class="btn btn-secondary" @click="closeModal()" :disabled="sending">
                <i class="fad fa-backspace"></i> Retour
            </button>
            <button type="button" class="btn btn-primary" @click="onSubmit" :disabled="sending || selectedOrders.length === 0">
                <i class="fad fa-shopping-cart"></i> Marquer comme distribuées
            </button>
        </template>
        <template #button="sp">
            <button class="btn btn-primary" @click="showModal()">
                <i class="fad fa-shopping-cart"></i> Marquer comme distribuées
            </button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../Modal";
    import ErrorsZone from "../../ErrorsZone";

    import {usePostRequest} from "../../compositions/axios/postRequest";

    export default {
        name: 'MarkMultipleShortChannelsOrdersInvoicedModal',

        components: {
            'modal': Modal,
            'errors-zone': ErrorsZone,
        },

        setup() {
            const {
                loading: sending,
                errors,
                post
            } = usePostRequest();

            return {
                sending,
                sendingErrors: errors,
                post
            };
        },

        props: {
            orders: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                displayedOrders: this.orders,
                allErrors: null,
                selectedOrders: [],
                sendingOrderId: null,
            }
        },

        methods: {
            showModal() {
                this.selectedOrders = this.displayedOrders.map((order) => order.id);
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },

            onModalClose() {
                this.allErrors = null;
            },

            async onSubmit() {
                this.allErrors = null;

                for (const orderId of this.selectedOrders) {
                    this.sendingOrderId = orderId;

                    try {
                        await this.post('/espace-employes/commandes/preparation/commande/' + orderId + '/confirmer-distribution');

                        if (this.sendingErrors) {
                            if (!this.allErrors) {
                                this.allErrors = {};
                            }
                            this.allErrors[orderId] = this.sendingErrors;
                        } else {
                            this.displayedOrders = this.displayedOrders.filter((o) => o.id != orderId);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }

                this.sendingOrderId = null;

                if (!this.allErrors) {
                    this.closeModal();

                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            },
        },
    }
</script>

<style lang="scss">
    .mark-multiple-short-channels-orders-invoiced-modal .modal-container {
        max-width: 600px;
        width: auto;
    }
</style>
